import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as RadiationAreaActions from './radiation-area.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class RadiationAreaStoreAndListenersService {

  constructor(
    private store: Store,
    private signalRService: SignalRService
  ) { }

  initStore() {
    this.store.dispatch(new RadiationAreaActions.RadiationAreaRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.RADIATIONAREA, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new RadiationAreaActions.RadiationAreaCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new RadiationAreaActions.RadiationAreaUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new RadiationAreaActions.RadiationAreaDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new RadiationAreaActions.RadiationAreaRefresh());
          break;
      }
    });
  }
}
